import { render, staticRenderFns } from "./RisksAnalysis.vue?vue&type=template&id=35c4cb12&scoped=true&"
import script from "./RisksAnalysis.vue?vue&type=script&lang=ts&"
export * from "./RisksAnalysis.vue?vue&type=script&lang=ts&"
import style0 from "./RisksAnalysis.vue?vue&type=style&index=0&id=35c4cb12&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c4cb12",
  null
  
)

export default component.exports